<template>
  <div class="SiteHeader">

    <div class="SiteHeader-headroom"
      ref="headroom">

      <container class="SiteHeader-container">

        <div class="SiteHeader-content">

          <component class="SiteHeader-logo"
            :is="!blockMenu ? 'router-link' : 'div'"
            :to="{ name: 'home' }">

            <logo @click.native="hideMenu" />

          </component>

          <nav class="SiteHeader-menu"
            v-if="!blockMenu">

            <router-link class="SiteHeader-menuItem"
              v-for="(item, index) in global.menu"
              :key="'menuItem' + index"
              :to="{ path: item.path }">
              {{ item.title }}
            </router-link>

          </nav>

        </div>

      </container>

      <div class="SiteHeader-menuButton"
        v-if="!blockMenu">

        <overlay-toggle
          @click.native="toggleMenu"
          inactive-label="Menu"
          active-label="Close"
          icon="plus"
          :is-active="menu.isVisible">

        </overlay-toggle>

      </div>

    </div>

  </div>
</template>

<script>
import Headroom from 'headroom.js'

export default {
  name: 'SiteHeader',

  props: {
    /**
     * TODO: remove this after launch
     * This is here to hide the menu from client pages, before the site launches.
     */
    blockMenu: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    window () { return this.$store.state.window },
    menu () { return this.$store.state.menu }
  },

  mounted () {
    this.$nextTick(this.init)
  },

  destroyed () {
    this.cleanup()
  },

  methods: {
    /**
     * Initialize
     */
    init () {
      this.headroom = new Headroom(this.$refs.headroom, {
        offset: 120,
        tolerance: {
          up: 20,
          down: 0
        }
      })

      this.headroom.init()
    },

    /**
     * Clean up events
     */
    cleanup () {
      if (!this.headroom) return
      this.headroom.destroy()
    },

    /**
     * Toggle menu
     */
    toggleMenu () {
      this.$store.dispatch('menu/toggle')
    },

    /**
     * Hide menu
     */
    hideMenu () {
      this.$store.dispatch('menu/hide')
    }
  }
}
</script>

<style>
@import 'properties';

:root {
  --sm-height: 96px;
  --lg-height: 120px;
}

/**
 * Space-holder for header
 * height must match .SiteHeader-headroom
 */
.SiteHeader {
  height: var(--sm-height);

  @media (min-width: 600px) {
    height: var(--lg-height);
  }
}

.theme-dk .SiteHeader {
  background: var(--c-grey-dk);
}

.SiteHeader-headroom {
  position: fixed;
  z-index: 900;
  top: 0;
  right: 0;
  left: 0;
  height: var(--sm-height);
  background-color: var(--c-black-alt);
  -webkit-font-smoothing: antialiased;

  will-change: transform;
  transition: transform 0.2s;

  @media (min-width: 600px) {
    height: var(--lg-height);
  }
}

.SiteHeader-headroom.headroom--unpinned {
  transform: translateY(-100%);
}

.SiteHeader-headroom.headroom--pinned {
  transform: translateY(0%);
}

.App--viewerIsOpen .SiteHeader-headroom.headroom--unpinned,
.App--shareModalIsOpen .SiteHeader-headroom.headroom--unpinned {
  transform: translateY(-100%);
  transition: none;
}

.SiteHeader-container {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 21px; /* Subtract 3px from 24px to account for leading */
}

.SiteHeader-content {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: baseline;

  @media (min-width: 600px) {
    justify-content: space-between;
  }
}

.SiteHeader-logo {

}

.SiteHeader-menu {
  display: none;

  @media (min-width: 600px) {
    display: flex;
  }
}

.SiteHeader-menuItem {
  font-size: 13px;
  line-height: 1em;
  font-weight: 400;
  color: var(--c-grey-xlt) !important;

  @media (min-width: 640px) {
    font-size: 15px;
  }
}

.SiteHeader-menuItem:hover,
.SiteHeader-menuItem.router-link-active {
  color: var(--c-white) !important;
}

.SiteHeader-menuItem + .SiteHeader-menuItem {
  margin-left: var(--unit);

  @media (min-width: 760px) {
    margin-left: var(--unit-2);
  }
}

.SiteHeader-menuButton {
  position: absolute;
  top: 0;
  right: 0;

  @media (min-width: 600px) {
    display: none;
  }
}

.SiteHeader-menuButton .OverlayToggle--isActive .OverlayToggle-icon svg {
  /* fill: var(--c-blue) !important; */
}

.SiteHeader-menuButton .OverlayToggle--isActive .OverlayToggle-label {
  /* color: var(--c-blue); */
}
</style>



// WEBPACK FOOTER //
// SiteHeader.vue?0b31dd7e